import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './ReportViewer.css';

const ReportViewer = ({ reportPath }) => {
    const [markdownContent, setMarkdownContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMarkdown = async () => {
            try {
                setLoading(true);
                const response = await fetch(reportPath);
                if (!response.ok) {
                    throw new Error(`Failed to load report: ${response.status}`);
                }
                const content = await response.text();
                setMarkdownContent(content);
                setError(null);
            } catch (err) {
                setError(err.message);
                console.error('Error loading markdown:', err);
            } finally {
                setLoading(false);
            }
        };

        if (reportPath) {
            fetchMarkdown();
        }
    }, [reportPath]);

    if (loading) {
        return (
            <div className="report-viewer">
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Loading report...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="report-viewer">
                <div className="error-container">
                    <h2>Error Loading Report</h2>
                    <p>{error}</p>
                    <button onClick={() => window.history.back()} className="back-btn">
                        Go Back
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="report-viewer">
            <div className="report-container">
                <div className="markdown-content">
                    <ReactMarkdown 
                        remarkPlugins={[remarkGfm]}
                        components={{
                            // Custom styling for different markdown elements
                            h1: ({ children }) => <h1 className="report-title">{children}</h1>,
                            h2: ({ children }) => <h2 className="report-section">{children}</h2>,
                            h3: ({ children }) => <h3 className="report-subsection">{children}</h3>,
                            table: ({ children }) => <table className="report-table">{children}</table>,
                            th: ({ children }) => <th className="table-header">{children}</th>,
                            td: ({ children }) => <td className="table-cell">{children}</td>,
                            code: ({ children }) => <code className="inline-code">{children}</code>,
                            pre: ({ children }) => <pre className="code-block">{children}</pre>,
                            blockquote: ({ children }) => <blockquote className="blockquote">{children}</blockquote>,
                            ul: ({ children }) => <ul className="report-list">{children}</ul>,
                            ol: ({ children }) => <ol className="report-list">{children}</ol>,
                            li: ({ children }) => <li className="list-item">{children}</li>,
                            strong: ({ children }) => <strong className="bold-text">{children}</strong>,
                            em: ({ children }) => <em className="italic-text">{children}</em>,
                        }}
                    >
                        {markdownContent}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    );
};

export default ReportViewer; 